
const doctorInfo = {
    english: [
        {
            id: 0,
            name: "Michael Han",
            title: "Registered Traditional Chinese Medicine Practitioner and Acupuncturist in BC. Doctor of TCM.",
            description: "Registered Chinese Medicine Practitioner and Acupuncturist of BC. Doctor of TCM, Professor, and Master's Supervisor at Shanghai University of TCM. With nearly 30 years of experience in teaching, scientific research, and clinical practice TCM. Recognized as the outstanding TCM talents by the National Administration of TCM. Expertise in the prescription of TCM, with specialization in cardiovascular and digestive disorders, as well as gynecological and pediatric conditions. Proficient in acupuncture, Acupressure to treat pain."
        },
        {
            id:1,
            name: "Lulu Li",
            title: "Reception",
            description: ""
        },
    ],
    chinese: [
        {
            id:0,
            name: "Michael Han",
            title: "加拿大BC省注册中医师、针灸师, 中医学博士",
            description: "加拿大BC省注册中医师、针灸师。中医学博士，上海中医药大学教授，硕士研究生导师；中医方剂学等教学、科研及临床近30年。国家中医药管理局第四批中医优才。上海中医药大学附属曙光医院传统中医科门诊专家；上海市浦东新区中医医院门诊专家；上海市安济中医医院门诊专家。曾主持国家自然基金和上海市教委基金等项目。擅长中药治疗心血管、脾胃等内科杂病，及妇科、儿科等杂症；并针灸、推拿、理筋正骨。"
        },
        {
            id:1,
            name: "Lulu Li",
            title: "前台",
            description: ""
        },
    ]
}

export default doctorInfo;